export const STAGE_LABELS: Record<string, string> = {
  applied: "Applied",
  assignment: "Assignment",
  review: "Review",
  interview: "Interview",
  interview_complete: "Interview Complete",
  offer_pending: "Offer Pending",
  offer: "Hired",
  rejected: "Rejected",
  withdrawn: "Withdrawn",
  talent_pool: "Talent Pool",
};

export const CANDIDATE_STAGE_LABELS: Record<string, string> = {
  applied: "Under review",
  assignment: "Under review",
  review: "Under review",
  interview: "Under review",
  interview_complete: "Under review",
  offer_pending: "Under review",
  offer: "Under review",
  rejected: "Not selected",
  withdrawn: "Withdrawn",
  talent_pool: "Not selected",
};

export const STAGE_COLORS: Record<string, string> = {
  applied: "bg-blue-100 text-blue-800",
  assignment: "bg-yellow-100 text-yellow-800",
  review: "bg-purple-100 text-purple-800",
  interview: "bg-indigo-100 text-indigo-800",
  interview_complete: "bg-teal-100 text-teal-800",
  offer_pending: "bg-emerald-100 text-emerald-800",
  offer: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
  withdrawn: "bg-gray-100 text-gray-600",
  talent_pool: "bg-amber-100 text-amber-800",
};
